<template>
  <a-modal
    class="modal-content"
    :title="title"
    :width="600"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <a-form-model
      ref="ruleForm"
      :labelCol="{ span: 24 }"
      :wrapperCol="{ span: 24 }"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item label="填写上报内容" prop="comment">
        <a-textarea
          v-model="form.comment"
          :auto-size="{ minRows: 5, maxRows: 8 }"
          placeholder="请填写上报内容"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { postAction } from '@/api/manage'

export default {
  name: 'ReportModal',
  props: {
    title: {
      type: String,
      default: '上报',
    },
  },
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        comment: [
          {
            required: true,
            message: '请输入上报内容',
            trigger: 'blur',
          },
        ],
      },
      currRecord: {},
    }
  },
  methods: {
    showModal(data, index) {
      this.visible = true
      this.currRecord = data
      console.log('记录信息：', this.currRecord)
    },
    hideModal() {
      this.visible = false
      // 清除验证
      this.$refs.ruleForm.clearValidate()
    },
    async handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const params = {
            id: this.currRecord.id,
            warnStatus: 6,
            comment: '已上报，' + this.form.comment || '',
            visible: 1,
          }
          console.log('上报参数：', params)
          const res = await postAction('/aigoes/schoolWarnRecord/warnProcess', params)
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('refreshData')
          } else {
            this.$message.error(res.message || '保存失败')
          }
          console.log('提交结果：', res)
          this.hideModal()
        }
      })
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-modal-header {
    border-bottom: none;
  }
  /deep/ .ant-modal-body {
    padding: 0 24px 10px;
  }
  /deep/ .ant-upload {
    height: 149px;
  }
}
</style>
